export default "__VITE_ASSET__7d4b20bb__"